import PopupComponent from '../PopupComponent';

export default class CartPopup extends PopupComponent {
	constructor() {
		super({
			element: '.popup--cart',
			elements: {
				description: '.popup__product-description',
				title: "#popup-cart-title",
				size: "#popup-cart-size",
				frame: "#popup-cart-frame",
				price: "#popup-cart-price",
				img: '.popup__product-image',
				btnContinueShopping: '#continue-shopping-btn',
				btnCheckout: '#checkout-btn',
			},
		});
	}

	insertProduct(product) {
		this.elements.title.innerHTML = product.title;
		this.elements.size.innerHTML = product.size.name;
		this.elements.frame.innerHTML = product.frame.name;
		this.elements.price.innerHTML = product.pricestring;
		this.elements.img.src =  'images/store/' + product.number + '/' + 'w507-' + product.images[0].src;
		this.elements.img.alt = product.images[0].alt || product.title;
	}

	addEventListeners() {
		super.addEventListeners();
		this.elements.btnContinueShopping.addEventListener('click', () => {
			this.hide();
		});
		this.elements.btnCheckout.addEventListener('click', () => {
			this.$emit('viewShoppingCart');
			this.hide(false);
		});
	}

	show() {
		super.show();
		this.$emit('stopScroll');
	}

	hide(startScroll = true) {
		super.hide();
		if (startScroll) this.$emit('startScroll');
	}
}
